let initialized = false;
/**
 * Initializes the api module. Must be called before the module can be used to make API requests.
 * @param dependencyGetter - this returns the latest version of the dependencies of API requests, e.g. accessToken
 */
export function initializeClient(dependencyGetter) {
    if (initialized) {
        // TODO(gellert): figure out why its being called in web assistant.
        // throw new Error("api state client already initialized");
        console.log("api state client already initialized");
    }
    getClientDependencies = dependencyGetter;
    initialized = true;
}
export function isClientInitialized() {
    return initialized;
}
export let getClientDependencies = () => {
    throw new Error("initializeClient must be called before API requests are made");
};
